import React from 'react';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Main from './components/Main.js'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#E1F2FB',
    },
    secondary: {
      main: '#E9B2BC',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Main />
    </ThemeProvider>

  );
}

export default App;
